import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { buildFAQSchema } from '@/components/seo/AutoSEOOptimizer';

// Inject JSON-LD for key services and page-specific FAQ (when available)
const SEOJsonLd: React.FC = () => {
  const { pathname } = useLocation();

  const faqSchema = useMemo(() => {
    try {
      const schema = buildFAQSchema?.(pathname);
      if (schema && Array.isArray(schema.mainEntity) && schema.mainEntity.length > 0) {
        return schema;
      }
    } catch (_) {}
    return null;
  }, [pathname]);

  const serviceSchema = useMemo(() => {
    const regions = ['Occitanie', 'Auvergne', 'Île-de-France'];
    const areaServed = regions.map((name) => ({ '@type': 'AdministrativeArea', name }));

    const provider = {
      '@type': 'Organization',
      name: 'Groupe Fabre Environnement',
      url: 'https://www.groupefabre-environnement.fr'
    };

    return {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Service',
          name: 'Location de bennes',
          serviceType: 'Location de bennes',
          provider,
          areaServed
        },
        {
          '@type': 'Service',
          name: 'Achat de métaux (ferreux et non ferreux)',
          serviceType: 'Achat de métaux',
          provider,
          areaServed
        }
      ]
    } as Record<string, any>;
  }, []);

  return (
    <Helmet>
      {/* Services clés */}
      <script type="application/ld+json">{JSON.stringify(serviceSchema)}</script>
      {/* FAQ spécifique à la page si disponible */}
      {faqSchema && (
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      )}
    </Helmet>
  );
};

export default SEOJsonLd;
